module.exports = __webpack_public_path__ + "static/media/pc-video.3ec4150.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/pc-video.mp4
// module id = 5pYI
// module chunks = 0